module.exports = __webpack_public_path__ + "cba8e90503370863b3a0036bda7b0e44.woff";